// Shared UK (en-GB) date + datetime formatting used across Estatel AI.
//
// Single source of truth so every date reads identically (e.g. "21 Feb 2026"
// or "21 Feb 2026, 14:30") regardless of component. Accepts ISO strings,
// Date objects, or raw millisecond numbers.
//
// Examples:
//   formatDate('2026-02-21')           → '21 Feb 2026'
//   formatDateTime('2026-02-21T14:30Z')→ '21 Feb 2026, 14:30'
//   formatDate(null)                   → '—'
//   timeAgo(Date.now() - 3600_000)     → '1h ago'
//

const DATE_FMT = new Intl.DateTimeFormat('en-GB', {
  day: '2-digit', month: 'short', year: 'numeric',
});

const DATETIME_FMT = new Intl.DateTimeFormat('en-GB', {
  day: '2-digit', month: 'short', year: 'numeric',
  hour: '2-digit', minute: '2-digit', hour12: false,
});

function toDate(value) {
  if (value === null || value === undefined || value === '') return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDate(value, fallback = '—') {
  const d = toDate(value);
  return d ? DATE_FMT.format(d) : fallback;
}

export function formatDateTime(value, fallback = '—') {
  const d = toDate(value);
  return d ? DATETIME_FMT.format(d).replace(',', ',') : fallback;
}

// Lightweight "time-ago" — keeps things human for recent events, falls back
// to absolute date after a week.
export function timeAgo(value, fallback = '—') {
  const d = toDate(value);
  if (!d) return fallback;
  const diffMs = Date.now() - d.getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d ago`;
  return formatDate(d);
}
